import { render, staticRenderFns } from "./homeDelivery.vue?vue&type=template&id=2695337f&scoped=true&"
import script from "./homeDelivery.vue?vue&type=script&lang=js&"
export * from "./homeDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695337f",
  null
  
)

export default component.exports